// Xero tab (BUILD_SPEC.md §5.9, §12; plan.md G26) — connection status/connect/
// disconnect, account/tax-rate mappings, and the push/sync action surface.
import { Stack } from '@mantine/core';
import { PageHeader } from '../../../components/PageHeader';
import { XeroConnectionCard } from './XeroConnectionCard';
import { XeroMappingsEditor } from './XeroMappingsEditor';
import { XeroSyncActions } from './XeroSyncActions';
import { XeroSyncHistory } from './XeroSyncHistory';

export function XeroPanel() {
  return (
    <Stack gap="xl">
      <PageHeader
        title="Xero"
        description="Connect once, map your accounts and tax rates, then push approved sales invoices, supplier bills and credit notes to Xero from Sync below. Payment status pulls automatically every night, or on demand. Sync history shows the result of every attempt."
      />
      <XeroConnectionCard />
      <XeroMappingsEditor />
      <XeroSyncActions />
      <XeroSyncHistory />
    </Stack>
  );
}
